<template>
  <v-card
    class="promo-content-card"
    :class="this.themeClass + ' ' + this.cardClassName"
    flat
    :hover="false"
  >
    <v-card-title>
      <slot name="cardIcon"></slot>
      <SitecoreMultiline :multilineField="this.cardTitleField" className="promo-content-title" />
    </v-card-title>
    <v-card-text class="promo-content-body">
      <SitecoreMultiline :multilineField="this.cardContentField" />
    </v-card-text>
    <v-card-actions class="promo-actions">
      <v-btn :loading="loading" @click="btnClick" tile class="promo-content-btn">
        <slot name="cardActions"></slot>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { isExperienceEditorActive } from '@sitecore-jss/sitecore-jss-vue';
import SitecoreMultiline from '../../Sitecore/SitecoreMultiline';
export default {
  name: 'BasePromoCard',
  data() {
    return {};
  },
  props: {
    cardClassName: {
      type: String,
      default: '',
    },
    cardTitleField: {
      type: Object,
      default: () => ({}),
    },
    cardContentField: {
      type: Object,
      default: () => ({}),
    },
    theme: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    themeClass() {
      let className = 'default';
      if (
        this.theme &&
        this.theme.fields &&
        this.theme.fields.ThemeClass &&
        this.theme.fields.ThemeClass.value !== ''
      ) {
        className = this.theme.fields.ThemeClass.value;
      }
      return className;
    },
    isSitecoreExperienceEditorOn() {
      // TODO may need to add other check like the preview mode
      return isExperienceEditorActive();
    },
  },
  methods: {
    btnClick() {
      if (this.isSitecoreExperienceEditorOn) {
        return;
      }

      // Emit the btn clicked to parent
      this.$emit('promo-card-button-clicked');
    },
  },
  components: {
    SitecoreMultiline,
  },
};
</script>
<style lang="scss" scoped>
.promo-content-card {
  border-radius: 2px !important;
  min-height: 250px;

  &::v-deep {
    .promo-content-title {
      min-height: 52px;
      font-size: 18px;
      line-height: 130%;
      font-weight: map-get($font-weights, 'normal');
      margin-bottom: 0px;
      display: block;
      word-break: normal;
    }
    .promo-content-body {
      font-size: 16px;
      line-height: 130%;
      font-weight: map-get($font-weights, 'light');
      padding-bottom: 60px;
      display: block;
      word-break: normal;
    }
  }
  .promo-actions {
    position: absolute;
    bottom: 0;
    padding-left: 16px;
    margin-bottom: 8px;
    .promo-content-btn {
      min-width: 150px;
      height: 48px;
      @media #{map-get($display-breakpoints, 'xs-only')} {
        font-size: 16px !important;
      }
      @media #{map-get($display-breakpoints, 'sm-and-up')} {
        font-size: 14px;
      }
    }
  }
}
</style>
